(function($, Drupal) {
  'use strict';

  Drupal.behaviors.heroSlider = {
    attach: function(context, settings) {
      // console.log('hero slider loaded');
      //* Adds Slick Slider to articles page, only if there are more than 1 image
      let $article_images = $('.article-top--slider .field--name-field-image-media').children().length;
      if ($article_images > 1) {
        $('.article-top--slider .field--name-field-image-media').slick({
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          centerMode: true
        });
      }

      // Theme page slider
      let $theme_images = $('.article-top--slider .field--name-field-theme-image').children().length;
      if ($theme_images > 1) {
        $('.article-top--slider .field--name-field-theme-image').slick({
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          centerMode: true
        });

        $('.article-top--slider img').each(function() {
          var $img = $(this);
          $img.attr('src', $img.attr('data-src'));
        });
      }

      $('.article-top--slider img').each(function() {
        var $img = $(this);
        // console.log($img.attr('src'), $img.attr('data-src'));
        $img.attr('src', $img.attr('data-src'));
        $img.removeAttr('style');
      });
    }
  };
})(jQuery, Drupal);
